/**
 * Tuile — le logo ou la photo d'une entrée : un carré très arrondi (jamais un rond). Une URL
 * devient une image, un nœud React est posé tel quel, rien du tout donne l'initiale du nom en
 * Almarena. `children` = ce qui se pose par-dessus (la pilule « Toi »).
 *
 * Depuis le lot 5 du catalogue (01-11-2026) c'est l'`Avatar` de la librairie, `arrondi`, habillé
 * par la famille (`.cl-tuile` : le dégradé sombre, l'anneau de la marche). Une photo qui ne
 * charge pas retombe sur l'initiale, et part sans Referer.
 */
import type { ReactNode } from "react";

import { Avatar } from "../Avatar";
import { cn } from "../utils";

export { initiale } from "../Avatar";

export interface TuileProps {
  icone?: ReactNode | string;
  nom: string;
  /** Côté, en px ou en expression CSS (`clamp(...)`). */
  taille: number | string;
  className?: string;
  children?: ReactNode;
}

export function Tuile({ icone, nom, taille, className, children }: TuileProps) {
  return (
    <Avatar
      forme="arrondi"
      src={typeof icone === "string" && icone !== "" ? icone : undefined}
      icone={typeof icone !== "string" ? icone : undefined}
      nom={nom}
      taille={taille}
      className={cn("cl-tuile", className)}
    >
      {children}
    </Avatar>
  );
}
